module.exports = __webpack_public_path__ + "static/media/karina.ea614162.png";